export default {
    cn: {
        autoPositionReport: {
            accHead: [
                { key: 'id', value: '配置编号' },
                // { key: 'conf_key', value: '配置类型' },
                { key: 'conf_desc', value: '配置描述' },
                { key: 'value', value: '配置关键值' },
                { key: 'modify_time', value: '最后修改时间' },
                { key: 'modify_by', value: '最后修改人' },
            ],
            miutesRulesRequired: '请输入每小时报仓的分钟数',
            miutesRulesNumber: '每小时报仓分钟数必须为正整数',
            managerRulesRequired: '请输入MT5经理账号',
            managerRulesNumber: 'MT5经理账号必须为正整数',
            securityRulesRequired: '请填写产品大类名称',
            maxCountRulesRequired: '请填写最大显示数',
            maxCountRulesNumber: '最大显示数必须为正整数',
            typeRulesRequired: '请选择产品组',
            specialSymbolRulesRequired: '请选择特殊产品',
            specialSecurityRulesRequired: '请选择特殊产品组',
            convRulesNumber: '数值转换必须是数字',
            addBtnTxt: '新增配置项',
            addDialogTitle: '请填写配置信息',
            confKeyOpt: {
                security: '产品大类',
                manager: 'MT5经理账号',
                specialSecurity: '特殊配置',
                showMaxCount: '最大显示数',
                minutes: '报仓时间',
            },
            confValLabelOpt: {
                confType: '配置描述',
                minutes: '每小时第几分钟报仓(0-59)(未设置默认5)',
                manager: 'MT5经理账号',
                security: '产品大类名称(例如主要外汇/贵金属等)',
                showMaxCount: '每个大类最大产品显示数(小于等于0或者未设置默认为7)',
                tittle: '标题',
                types: '产品组列表',
                abandonedRange: '不报仓净手数范围(开区间,没有设置则不限制手数)',
                specialSymbol: '特殊产品',
                specialSecurity: '特殊产品组',
                conv: '数值转换(手数和盈亏乘以该数值再报仓，未设置默认为1)'
            },
            descContent: {
                security: '产品大类 - 选择什么产品组会在同一个产品大类里面报仓。另外可控制在多少手数内的仓位可以略过不报',
                manager: 'MT5经理账号 - 按照什么经理账号的权限去报仓',
                specialSecurity: '特殊配置 - 把个别产品放入指定产品组来报仓',
                showMaxCount: '最大显示数 - 设置每个产品大类会展示最多多少产品的报仓',
                minutes: '报仓时间 - 每小时什么时间开始报仓',
            },
            formSelectDefaultTxt: '请选择',
            formConfValLabel: '配置参数',
            formCancelTxt: '取 消',
            formConfirmTxt: '确 定',
            deleteMsgTxt: '确定要删除这个配置吗？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失败',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失败',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失败',
            lastTableColumnTxt: '操作',
        }
    },
    hk: {
        autoPositionReport: {
            accHead: [
                { key: 'id', value: '配置編號' },
                // { key: 'conf_key', value: '配置類型' },
                { key: 'conf_desc', value: '配置描述' },
                { key: 'value', value: '配置關鍵值' },
                { key: 'modify_time', value: '最後修改時間' },
                { key: 'modify_by', value: '最後修改人' },
            ],
            miutesRulesRequired: '請輸入每小時報倉的分鐘數',
            miutesRulesNumber: '每小時報倉分鐘數必須為正整數',
            managerRulesRequired: '請輸入MT5經理賬號',
            managerRulesNumber: 'MT5經理賬號必須為正整數',
            securityRulesRequired: '請填寫產品大類名稱',
            maxCountRulesRequired: '請填寫最大顯示數',
            maxCountRulesNumber: '最大顯示數必須爲正整數',
            typeRulesRequired: '請選擇產品組',
            specialSymbolRulesRequired: '請選擇特殊產品',
            specialSecurityRulesRequired: '請選擇特殊產品組',
            convRulesNumber: '數值轉換必須是數字',
            addBtnTxt: '新增配置項',
            addDialogTitle: '請填寫配置信息',
            confKeyOpt: {
                security: '產品大類',
                manager: 'MT5經理賬號',
                specialSecurity: '特殊配置',
                showMaxCount: '最大顯示數',
                minutes: '報倉時間',
            },
            confValLabelOpt: {
                confType: '配置描述',
                minutes: '每小時第幾分鐘報倉(0-59)(未設置默認5)',
                manager: 'MT5經理賬號',
                security: '產品大類名稱(例如主要外匯/貴金屬等)',
                showMaxCount: '每個大類最大產品顯示數(小於等於0或者未設置默認為7)',
                tittle: '標題',
                types: '產品組列表',
                abandonedRange: '不報倉净手數範圍(開區間,未設置則不限制手數)',
                specialSymbol: '特殊產品',
                specialSecurity: '特殊產品組',
                conv: '數值轉換(手數和盈虧乘以該數值再報倉，未設置默認為1)'
            },
            descContent: {
                security: '產品大類 - 選擇什麽產品組會在同一個產品大類裏面報倉。另外可控制在多少手數内的倉位可以略過不報',
                manager: 'MT5經理賬號 - 按照什麽經理賬號的權限去報倉',
                specialSecurity: '特殊配置 - 把個別產品放入指定產品組來報倉',
                showMaxCount: '最大顯示數 - 設置每個產品大類會展示最多多少產品的報倉',
                minutes: '報倉時間 - 每小時什麽時間開始報倉',
            },
            formSelectDefaultTxt: '請選擇',
            formConfValLabel: '配置參數',
            formCancelTxt: '取 消',
            formConfirmTxt: '確 定',
            deleteMsgTxt: '確定要刪除這個配置嗎？',
            notifyTxt: '提示',
            addSuccess: '新增配置成功',
            addFailed: '新增配置失敗',
            updateSuccess: '更新配置成功',
            updateFailed: '更新配置失敗',
            delSuccess: '移除配置成功',
            delFailed: '移除配置失敗',
            lastTableColumnTxt: '操作',
        }
    },
    en: {
        autoPositionReport: {
            accHead: [
                { key: 'id', value: 'ID' },
                // { key: 'conf_key', value: 'Type' },
                { key: 'conf_desc', value: 'Description' },
                { key: 'value', value: 'Value' },
                { key: 'modify_time', value: 'Modify Time' },
                { key: 'modify_by', value: 'Modify By' },
            ],
            miutesRulesRequired: 'Please enter the minutes of the hourly position report',
            miutesRulesNumber: 'Hourly position reporting minutes must be a positive integer',
            managerRulesRequired: 'Please enter the MT5 manager account',
            managerRulesNumber: 'MT5 manager account number must be a positive integer',
            securityRulesRequired: 'Please fill in the product name',
            maxCountRulesRequired: 'Please fill in the maximum number of display',
            maxCountRulesNumber: 'The maximum display number must be a positive integer',
            typeRulesRequired: 'Please select securities',
            specialSymbolRulesRequired: 'Please select special symbols',
            specialSecurityRulesRequired: 'Please select a special security',
            convRulesNumber: 'Conv must be a number',
            addBtnTxt: 'Add a new configuration',
            addDialogTitle: 'Please fill in the configuration information',
            confKeyOpt: {
                security: 'Product',
                manager: 'MT5 manager account',
                specialSecurity: 'Special configuration',
                showMaxCount: 'Maximum number of display',
                minutes: 'Report minutes',
            },
            confValLabelOpt: {
                confType: 'Configuration description',
                minutes: 'The minute of the hour to report the position(0-59)(default 5 if not set)',
                manager: 'MT5 manager account',
                security: 'Product name (such as 主要外匯/貴金屬 etc.)',
                showMaxCount: 'Max symbols displayed for each produce(less than or equal to 0 or not set to 7 by default)',
                tittle: 'Tittle',
                types: 'Secutity list',
                abandonedRange: 'Net lot size range without reporting positions(open range, no limit on lot size if not set)',
                specialSymbol: 'Special symbols',
                specialSecurity: 'Special security',
                conv: 'Conv(Multiply the number of lots and PL by this value before position report, the default value is 1 if not set)'
            },
            descContent: {
                security: 'Product - Choose which securities to be grouped into a product name for the purpose of reporting. A net lot size range is also available to omit reports that fall within the designated net positions',
                manager: 'MT manager account - Proceed with the reporting based on the privilege bounded by a particular MT manager account',
                specialSecurity: 'Special configuration - Force particular symbols into certain security group for the purpose of reporting',
                showMaxCount: 'Maximum number of display - Set the maximum number of symbols to be displayed within each Product',
                minutes: 'Report minutes - Denotes the minute in each hour reporting will be announced',
            },
            formSelectDefaultTxt: 'Please select',
            formConfValLabel: 'Configuration parameters',
            formCancelTxt: 'Cancel',
            formConfirmTxt: 'OK',
            deleteMsgTxt: 'Are you sure you want to delete this configuration?',
            notifyTxt: 'Notify',
            addSuccess: 'Add configuration successfully',
            addFailed: 'Failed to add configuration',
            updateSuccess: 'Update configuration successfully',
            updateFailed: 'Failed to update configuration',
            delSuccess: 'Delete configuration successfully',
            delFailed: 'Failed to delete configuration',
            lastTableColumnTxt: 'Handle',
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/report/autoPositionReport.js